import axios from "axios";
import utils from "./utils";
import environment from "./environment";
import defaults from "./defaults";

/**
 * Class responsible for handling authentication requests and managing tenant data.
 */
class RequestAuth {

  /**
   * Creates an instance of the `RequestAuth` class.
   *
   * @param {Tenants} tenants - The tenants object that manages tenant data.
   */
  constructor(tenants) {
    /**
     * @property {Tenants} tenants - Instance of the Tenants class.
     */
    this.tenants = tenants;

    /**
     * @property {string} accountEndpoint - The API endpoint for authentication requests.
     */
    this.accountEndpoint = environment.isLocal()
      ? 'https://account.nxp.dev/v1/oauth2'
      : 'https://account.stonexl.com/v1/oauth2';

    /**
     * @property {Object} requestConfig - Default configuration for HTTP requests.
     */
    this.requestConfig = {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  }

  /**
   * @param {String} email
   * @param {String} password
   * @returns {Promise<*>}
   */
  async loginRequest(email, password) {
    const response = await axios.post(
      this.accountEndpoint + '/login',
      {
        email: email,
        password: password
      },
      this.requestConfig
    );

    if (response.status === 200) {
      const responseData = response.data;
      utils.log('responseData', responseData);

      if (responseData.status === 'success') {
        const data = responseData.data;
        utils.log('data', data);

        if (environment.isLocal()) {
          data.tenants.map((tenant) => {
            tenant.endpoint = tenant.endpoint.replace('.com', '.ddev.site:8443');
            return tenant;
          });
        }

        // Store tenant data
        this.tenants.set(data.tenants);

        defaults.update(this.tenants);

        return data;
      } else {
        throw new Error('Incorrect username or password');
      }

    } else {
      //utils.errorMessage('Authentication request failed.');
      throw new Error(`Invalid status code: ${response.status}`);
    }
  }

  /**
   * Sends a token issuance request for a specific tenant.
   *
   * @param {string} ticket - The ticket provided during the authentication process.
   * @param {string} tenantKey - The key identifying the tenant.
   * @returns {Promise<Object>} Resolves with the issued tokens if successful.
   * @throws {Error} If the request fails or the response status is not 200.
   */
  async issueTokensRequest(ticket, tenantKey) {
    const response = await axios.post(
      this.accountEndpoint + '/tenant/issue',
      {
        ticket: ticket,
        tenant_key: tenantKey
      },
      this.requestConfig
    );

    // Check if the response was successful
    if (response.status === 200) {
      utils.log('Tokens response:', response.data);

      const responseData = response.data;

      if (responseData.status === 'success') {
        const data = responseData.data;

        // TODO: store tokens and login

        utils.log('issueTokensRequest data', data);

        this.tenants.getCurrent().accessToken = data.access_token;
        this.tenants.getCurrent().refreshToken = data.refresh_token;

        defaults.update(this.tenants);

        return data;
      } else {
        throw new Error('Token issuance request failed.');
      }

    } else {
      //utils.errorMessage('Token issuance request failed.');
      throw new Error(`Unexpected status code: ${response.status}`);
    }

  }

  /**
   * Sends a token refresh request for a specific tenant.
   *
   * @param {string} refreshToken - The refresh token of the tenant.
   * @returns {Promise<Object>} Resolves with the new tokens if successful.
   * @throws {Error} If the request fails or the response status is not 200.
   */
  async refreshTokensRequest(refreshToken) {
    const response = await axios.post(
      this.accountEndpoint + '/tenant/refresh',
      {
        refresh_token: refreshToken
      },
      this.requestConfig
    );

    // Check if the response was successful
    if (response.status === 200) {
      utils.log('Tokens response:', response.data);

      const responseData = response.data;

      if (responseData.status === 'success') {
        const data = responseData.data;

        // TODO: store tokens and login

        utils.log('refreshTokensRequest data', data);

        this.tenants.getCurrent().accessToken = data.access_token;
        this.tenants.getCurrent().refreshToken = data.refresh_token;

        defaults.update(this.tenants);

        return data;
      } else {
        throw new Error('Token refresh request failed.');
      }

    } else {
      //utils.errorMessage('Token issuance request failed.');
      throw new Error(`Unexpected status code: ${response.status}`);
    }

  }

}

export default RequestAuth;